export enum IdeasVisibility {
  visibleToAllUsers = 1,
  visibleToCreators = 2,
  visibleToCompanies = 3
}
